<template>
  <div>
    <RowItem
      first
      class="row-item"
      :title="$t('feed_in_system_details.request_date')"
      :editable="false"
    >
      {{ presentableFeedInSystem.requestDate }}
    </RowItem>
    <!-- Auftragsnummer -->
    <RowItem
      class="row-item"
      :title="$t('feed_in_system_details.order_number')"
      :editable="false"
    >
      {{ feedInSystem.case_number }}
    </RowItem>
    <!-- Einspeiseadresse -->
    <RowItem
      class="row-item"
      field="updatePVInstallationAddress"
      :title="$t('feed_in_system_details.feed_in_address')"
      :editable="!isEditingLocked"
      @edit="
        $emit('edit-component', {
          component: 'PhotovoltaicInstallationAddressComponent',
          location: 'ContractDetails',
          properties: feedInSystem,
        })
      "
    >
      <div v-html="presentableFeedInSystem.address"></div>
    </RowItem>
    <!-- Kontaktdaten -->
    <RowItem
      class="row-item"
      field="updatePVContactData"
      :title="$t('feed_in_system_details.contact_data')"
      :editable="!isEditingLocked"
      @edit="
        $emit('edit-component', {
          component: 'ContractContactComponent',
          location: 'ContractDetails',
          properties: feedInSystem,
        })
      "
    >
      <div v-html="presentableFeedInSystem.contactData"></div>
    </RowItem>
    <!-- abweichender Rechnungsempfänger -->
    <RowItem
      class="row-item"
      field="updatePVAlternateInvoiceRecipient"
      :title="$t('feed_in_system_details.alternate_invoice_recipient')"
      :editable="
        !isEditingLocked &&
        !disqualifiedStatusesForAlternateRecipientAndAlternateDeliveryAddress.includes(
          this.feedInSystemStatus
        )
      "
      @edit="
        $emit('edit-component', {
          component: 'CompactUserAndAddressFormComponent',
          location: 'ContractDetails',
          properties: { formName: 'invoiceRecipient' },
        })
      "
    >
      <div v-html="presentableFeedInSystem.alternateInvoiceRecipient"></div>
    </RowItem>
    <!-- abweichender Lieferadresse -->
    <RowItem
      class="row-item"
      field="updatePVAlternateDeliveryAddress"
      :title="$t('feed_in_system_details.alternate_delivery_address')"
      :editable="
        !isEditingLocked &&
        !disqualifiedStatusesForAlternateRecipientAndAlternateDeliveryAddress.includes(
          this.feedInSystemStatus
        )
      "
      @edit="
        $emit('edit-component', {
          component: 'CompactUserAndAddressFormComponent',
          location: 'ContractDetails',
          properties: { formName: 'deliveryAddress' },
        })
      "
    >
      <div v-html="presentableFeedInSystem.alternateDeliveryAddress"></div>
    </RowItem>
    <!-- Einspeisevergütung -->
    <RowItem
      v-if="!isPVAnfrage"
      class="row-item"
      field="updatePVFeedInCompensation"
      :title="$t('feed_in_system_details.feed_in_compensation')"
      :editable="!isEditingLocked"
      @edit="
        $emit('edit-component', {
          component: 'FeedInCompensationComponent',
          location: 'ContractDetails',
          properties: { hasProtokollStatus },
        })
      "
    >
      <div v-html="presentableFeedInSystem.feedInCompensation || '-'"></div>
    </RowItem>
    <!-- Vergütungssatz -->
    <!--     <RowItem
      class="row-item"
      :title="$t('feed_in_system_details.compensation_rate')"
      :editable="false"
      v-if="!isPVAnfrage"
    >
      TODO: get compensation_rate (i.e. 8,2 Cent pro kWh)
    </RowItem> -->
    <!-- Finanzwirtschaftliche Daten -->
    <RowItem
      v-if="!isPVAnfrage"
      class="row-item"
      field="updateFinanceData"
      :title="$t('feed_in_system_details.finance_data')"
      :editable="!isEditingLocked"
      @edit="
        $emit('edit-component', {
          component: 'FinanceDataComponent',
          location: 'ContractDetails',
          properties: feedInSystem,
        })
      "
    >
      <div v-html="presentableFeedInSystem.financeData || '-'"></div>
    </RowItem>
    <!-- Marktstammdatenregister -->
    <RowItem
      v-if="!isPVAnfrage"
      class="row-item"
      field="updatePVMaStRData"
      :title="$t('market_data_register.title')"
      :editable="!isEditingLocked"
      @edit="
        $emit('edit-component', {
          component: 'MarketDataRegisterComponent',
          location: 'ContractDetails',
          properties: feedInSystem,
        })
      "
    >
      <div>
        <div v-html="presentableFeedInSystem.maStR || '-'"></div>
      </div>
      <div
        v-if="hasDuplicateMarketRegisterNumbers"
        class="step-warning-text mt-3 d-flex align-start"
        role="alert"
      >
        <v-icon color="amber darken-2" class="mr-2" aria-hidden="true">
          mdi-alert
        </v-icon>
        <span>{{ $t('market_data_register.duplicate_numbers_warning') }}</span>
      </div>
    </RowItem>
    <!-- Elektrofachbetrieb -->
    <RowItem
      :key="presentableFeedInSystem.plantConstructor"
      class="row-item"
      field="updatePVElectricInstallerCompany"
      :title="$t('feed_in_system_details.plant_constructor')"
      :editable="!isEditingLocked"
      @edit="
        $emit('edit-component', {
          component: 'ElectricInstallerCompaniesComponent',
          location: 'ContractDetails',
          properties: { allInstallerCompanies: fetchedInstallerCompanies },
        })
      "
    >
      {{
        presentableFeedInSystem.plantConstructor
          ? presentableFeedInSystem.plantConstructor
          : presentablePlantConstructor
      }}
    </RowItem>
    <!-- Zählernummer -->
    <RowItem
      class="row-item"
      field="updatePVCounterId"
      :withLineHeight="true"
      :title="counter_number_title"
      :editable="!isEditingLocked"
      @edit="
        $emit('edit-component', {
          component: 'CounterAvailabilityComponent',
          location: 'ContractDetails',
          properties: feedInSystem,
        })
      "
    >
      <div
        v-if="feedInSystem.counter_id_data"
        class="counter-preview"
        v-html="counterNumberPreview.content"
      ></div>
      <div v-else v-html="presentableFeedInSystem.counterNumber"></div>
    </RowItem>
    <!-- Zählerdaten -->
    <div
      v-if="
        isPVInbetriebnahmeProtokoll &&
        this.feedInSystem.pvimplementationprotocol_inspection
      "
    >
      <RowItem
        v-for="(item, index) in transformedCounters"
        v-bind:key="index"
        class="row-item"
        field="updatePhotovoltaics"
        :title="buildLabels(item, index)"
        :editable="!isEditingLocked"
        @edit="
          $emit('edit-component', {
            component: 'UpdateCounterDataComponent',
            location: 'ContractDetails',
            properties: {
              counter: item,
              indexOfCounter: index,
              allCounters:
                feedInSystem.pvimplementationprotocol_inspection.counters,
            },
          })
        "
      >
        <br /><br />
        <div v-for="(counterData, key) in item" :key="key">
          {{ formatCounterData(counterData, key) }}
        </div>
      </RowItem>
    </div>

    <!-- Inbetriebnahmetermin -->
    <RowItem
      last
      class="row-item"
      field="updatePVImplementationAppointment"
      :title="$t('feed_in_system_details.implementation_appointment')"
      :editable="!isEditingLocked"
      @edit="
        $emit('edit-component', {
          component: 'PVAppointmentDialog',
          location: 'ContractDetails',
          properties: { hasProtokollStatus },
        })
      "
    >
      <div>
        {{ presentableFeedInSystem.implementationAppointment || '-' }}
      </div>
    </RowItem>
  </div>
</template>

<script>
import RowItem from './RowItem';
import { hasDuplicateMarketRegisterNumbers } from '@/helpers/hasDuplicateMarketRegisterNumbers';
import { formatPVObject } from './transform_raw_data_to_pv_format';
import { formatCounterData } from '@/helpers/transformToPresentableData';
import InstallerCompaniesService from '../../services/InstallerCompaniesService';
import { PVJOURNEYS } from '@/helpers/constants';
import { FEED_IN_STATUSES } from '@/helpers/constants';

export default {
  name: 'ContractDetails',
  components: {
    RowItem,
  },
  props: {
    feedInSystem: Object,
    isEditingLocked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      FEED_IN_STATUSES: FEED_IN_STATUSES,
      disqualifiedStatusesForAlternateRecipientAndAlternateDeliveryAddress: [
        FEED_IN_STATUSES.tech_feas?.value,
        FEED_IN_STATUSES.created?.value,
        FEED_IN_STATUSES.confirmed?.value,
      ],
      fetchedInstallerCompanies: [],
      presentablePlantConstructor: '',
      /* make function available in template */
      formatCounterData: formatCounterData,
    };
  },
  async mounted() {
    await this.fetchInstallerCompanies();
  },
  computed: {
    hasDuplicateMarketRegisterNumbers() {
      return hasDuplicateMarketRegisterNumbers(this.feedInSystem);
    },
    hasProtokollStatus() {
      const protokollStatuses = [
        FEED_IN_STATUSES.fulfilled,
        FEED_IN_STATUSES.fulfilled_insp,
        FEED_IN_STATUSES.fulfilled_conf,
        FEED_IN_STATUSES.transmitted,
        FEED_IN_STATUSES.protocol_cancelled,
      ];

      return protokollStatuses.some(
        (status) => status.value === this.feedInSystem.status
      );
    },
    counter_number_title() {
      return this.counterNumberPreview.title;
    },
    counterNumberPreview() {
      const counters = this.feedInSystem?.counter_id_data || [];
      const countersToRemove = this.feedInSystem?.counters_to_remove_data || [];
      const titleLines = [
        this.$t('feed_in_system_details.counter_number_title'),
      ];
      const contentLines = [];

      counters.forEach((counter, index) => {
        contentLines.push(
          this.$t('technical_inspection.counter_data', {
            index: index + 1,
          })
        );
        contentLines.push(this.formatCounterNumber(counter));

        contentLines.push(this.formatEhzRequired(counter));

        contentLines.push(this.formatMsbProvider(counter.msb_provider));

        if (index < counters.length - 1 || countersToRemove.length > 0) {
          titleLines.push('');
          contentLines.push('');
        }
      });

      if (countersToRemove.length > 0) {
        countersToRemove.forEach((counter, index) => {
          contentLines.push(
            `${this.$t('counter_availability_step.counter_to_remove')} ${
              index + 1
            }`
          );
          contentLines.push(counter.counter_id || '-');
          if (index < countersToRemove.length - 1) {
            titleLines.push('');
            contentLines.push('');
          }
        });
      }

      const formatLines = (lines, fallbackDash = false) =>
        lines
          .map((line) => {
            if (line === '') return '';
            if (line === null || line === undefined || line === '') {
              return fallbackDash ? '-' : '';
            }
            return line;
          })
          .join('<br>');

      return {
        title: formatLines(titleLines),
        content: formatLines(contentLines, true) || '-',
      };
    },
    presentableFeedInSystem() {
      return formatPVObject(this.feedInSystem);
    },
    isPVAnfrage() {
      return this.feedInSystem.journey === PVJOURNEYS.pv;
    },
    isPVInbetriebnahmeProtokoll() {
      return this.feedInSystem.journey === PVJOURNEYS.pvip;
    },
    feedInSystemStatus() {
      return this.feedInSystem.status;
    },
    transformedCounters() {
      return this.feedInSystem.pvimplementationprotocol_inspection.counters?.map(
        (counter) => {
          if (counter.mount_type === 'DIN') {
            return {
              ...counter,
              mount_type: 'Hutschienen',
            };
          }
          return counter;
        }
      );
    },
  },
  methods: {
    formatCounterNumber(counter) {
      const number = counter?.counter_id;
      const twoWay = counter?.two_way_measurement_built_in
        ? `, ${this.$t('counter_availability_step.two_way_counter')}`
        : '';
      return number ? `${number}${twoWay}` : '-';
    },
    formatEhzRequired(counter) {
      return (
        this.$t('counter_availability_step.ehz_required_preview') +
        ': ' +
        (counter?.ehz_required ? this.$t('counter_availability_step.yes') : '-')
      );
    },
    formatMsbProvider(value) {
      const mapping = {
        new_netz: 'durch die NEW Netz',
        wmsb: 'durch einen wMSB',
      };
      if (!value) {
        return '-';
      }
      return (
        this.$t('counter_availability_step.msb_provider') +
        ': ' +
        (mapping[value] || value)
      );
    },
    buildLabels(item, index) {
      let label = `<span style="font-size: 18px;line-height:22px"><b>${this.$t(
        'feed_in_system_details.counter_data'
      )} ${
        this.feedInSystem.pvimplementationprotocol_inspection.counters.length >
        0
          ? index + 1
          : ''
      }</b></br>`;
      // eslint-disable-next-line no-unused-vars
      for (const [key, _] of Object.entries(item)) {
        label += `<br>${this.$t(`feed_in_system_details.${key}`)}`;
      }
      label += '</span>';
      return label;
    },
    async fetchInstallerCompanies() {
      try {
        const params = {
          zip: '',
          product: 'electricity',
        };
        const companies = await InstallerCompaniesService.getInstallerCompanies(
          params
        );
        this.fetchedInstallerCompanies = companies;
        if (!this.feedInSystem.installation_company_electricity) {
          this.fetchedInstallerCompanies.filter((company) => {
            if (
              company.Id ===
              this.feedInSystem.installation_company_electricity_id
            ) {
              this.presentablePlantConstructor = `${company.Firma}, ${company.Strasse} ${company.Hausnummer}, ${company.Plz} ${company.Ort}`;
            }
          });
        }
      } catch (err) {
        this.$frontendLogger.error(err);
      }
    },
  },
};
</script>

<style scoped>
.row-item {
  margin-block: 1px;
}
</style>
